import React from 'react';
// eslint-disable-next-line jira/restricted/styled-components, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { ThemeProvider } from 'styled-components';
import Spinner from '@atlaskit/spinner';
import withInjectedProps from '@atlassian/jira-common-util-with-injected-props';
import { ErrorBoundaryFlag as ErrorBoundary } from '@atlassian/jira-error-boundary-flag-renderer';
import { useProjectContext } from '@atlassian/jira-providers-project-context';
import { ServiceDeskAnalyticsContext } from '@atlassian/jira-servicedesk-analytics/src/ui/servicedesk-analytics-context/index.tsx';
import { ProjectNotFound } from '@atlassian/jira-servicedesk-spa-commons/src/common/utils/errors/index.tsx';
import { ProjectSubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/project-sub-product-updater/index.tsx';
import { ProjectSettingsController } from '@atlassian/jira-spa-apps-project-settings-common/src/components/routing-filter';
import { usePathParam as usePathParamDI } from '@atlassian/react-resource-router';
import ServiceDeskExternalLinks from './ui';

const METRICS_PAGE_ID = 'project-settings-apps.external-links-settings';

type Props = {
	usePathParam: typeof usePathParamDI;
};

export const ServiceDeskExternalLinksPage = (props: Props) => {
	const { usePathParam } = props;

	const { data: projectContext, loading: isProjectContextLoading } = useProjectContext();
	const [projectKey] = usePathParam('projectKey');
	const isProjectAdmin = Boolean(projectContext?.isProjectAdmin);

	const getExternalLinksContent = () => {
		if (isProjectContextLoading) {
			return <Spinner size="large" label="loading" />;
		}

		if (!isProjectAdmin) {
			return <ProjectNotFound />;
		}
		return <ServiceDeskExternalLinks projectContext={projectContext} />;
	};

	return (
		<ProjectSettingsController projectKey={projectKey}>
			<ErrorBoundary id={METRICS_PAGE_ID}>
				<ProjectSubProductUpdater />
				<ServiceDeskAnalyticsContext>
					<ThemeProvider theme={{}}>{getExternalLinksContent()}</ThemeProvider>
				</ServiceDeskAnalyticsContext>
			</ErrorBoundary>
		</ProjectSettingsController>
	);
};

export default withInjectedProps(ServiceDeskExternalLinksPage, {
	usePathParam: usePathParamDI,
});
